import React from 'react';
import ContentBox from '../../common/ContentBox';
import { Box, Divider, Link, Typography, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants';
import InvestorsArray from './components/InvestorsArray';
import { useTranslation } from 'react-i18next';
import InvestorsSexGraph from './components/InvestorsSexGraph';
import { useAppSelector } from '../../../store/reducers/store';
import InvestorsAgeGraph from './components/InvestorsAgeGraph';
import FundAllocationMap from './components/FundAllocationMap';
import { PortfolioGeographicDistribution } from '../../../models/Portfolio';
import { Utilities } from '../../../utility/utils';

const InvestorsTab: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    if (portfolio === undefined){
        return <></>;
    }
    const zones = portfolio.investors.map(i => i.split).filter(Utilities.distinct);
    const zoneData: PortfolioGeographicDistribution[] = zones.map(z => ({ zone: z, icon: "", proportion: portfolio.investors.filter(i => i.split === z).length / portfolio.investors.length}));

    return <>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestorsTopInvestors')}</Typography>
                    <Link component={NavLink} to={AUTHENTICATED_ROUTES.PORTFOLIO_DETAILS_INVESTORS_ROUTE.replace(':id', `${portfolio.id}`)}>{t('PortfolioDetailsInvestorsSeeAllInvestors')}</Link>
                </Box>
                <Divider sx={{ margin: "0 -32px"}} />
                <InvestorsArray />
            </Box>
        </ContentBox>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"} alignItems={"stretch"}>
                <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestorsDemographicSplit')}</Typography>
                <Box display={"flex"} gap={"17px"}>
                    <InvestorsSexGraph investors={portfolio.investors}  />
                    <Box width={"1px"} bgcolor={theme.palette.primary.main} />
                    <InvestorsAgeGraph investors={portfolio.investors} />
                </Box>
            </Box>
        </ContentBox>
        <ContentBox proportion={1}>
            <Box display={"flex"} flexDirection={"column"} gap={"10px"} alignItems={"stretch"}>
                <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestorsGeographicSplit')}</Typography>
                <FundAllocationMap allocations={zoneData} />
            </Box>
        </ContentBox>
    </>
}

export default InvestorsTab;